module.exports = __webpack_public_path__ + "img/google-play.0c5151a3.png";